module.exports = __webpack_public_path__ + "img/financial-ratio.d89e9022.svg";